module.exports = __webpack_public_path__ + "static/media/warning1.3125e56f.mp3";